import * as React from 'react'
import { ReactElement } from 'react'
import { Stack, StackItem } from '@fluentui/react'
import Loading from '../../components/Loading'
import { useRouteMatch } from 'react-router-dom'
import useFileData, { FileData } from '../../hooks/file/useFileData'
import useFilePages, { FilePageProps } from '../../hooks/file/useFilePages'
import ViewFileHeader from '../../components/File/ViewFileHeader'
import ViewFilePivotItems from '../../components/File/ViewFilePivotItems'

export type ViewFileProps = {
    file: FileData
    fileId: string
    activePage: FilePageProps
}

export default function ViewFile(): ReactElement {
    const routeMatch = useRouteMatch<{ fileId: string }>()
    const fileId = routeMatch.params?.fileId
    const { activePage } = useFilePages(fileId)
    const { file, getActivePageAction } = useFileData(fileId, activePage)

    if (!file.current.loaded || !activePage) {
        return <Loading />
    }

    return (
        <Stack tokens={{ childrenGap: 's1' }}>
            <ViewFileHeader file={file} fileId={fileId} activePage={activePage} />
            <ViewFilePivotItems file={file} fileId={fileId} activePage={activePage} />
            <StackItem>{activePage?.content(file, getActivePageAction())}</StackItem>
        </Stack>
    )
}
